import { resources as alertDetailResources } from '@atlassian/eoc-alert-detail/resources';
import { resources as alertListResources } from '@atlassian/eoc-alert-list/resources';
import { resources as teamDashboardResources } from '@atlassian/eoc-team-dashboard/resources';
import { getAutomationDiscoveryDismissResource } from '@atlassian/jira-router-resources-eoc-alert-detail/src/automation-dicovery-dismiss-resource/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { resourceWithCondition } from '@atlassian/jira-router-resources-utils/src/utils/resource-with-condition/index.tsx';
import { LazyAtlassianNavigation } from '@atlassian/jira-atlassian-navigation/src/async.tsx';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import AsyncSidebarEocTeamDashboard, {
	LazyTeamDashboardSidebar,
} from '@atlassian/jira-navigation-apps-sidebar-eoc-team-dashboard/src/async.tsx';
import { opsTeamLayout } from '@atlassian/jira-ops-team-layout/src/index.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { getConsolidationStateResource } from '@atlassian/jira-router-resources-eoc-tenant-info/src/services/index.tsx';
import { getNavigationResources } from '@atlassian/jira-router-resources-navigation/src/index.tsx';
import { eocTeamAlertDetailRoute } from '@atlassian/jira-router-routes-eoc-team-alerts-routes/src/eocTeamAlertDetailRoute.tsx';
import AlertList, { LazyAlertList } from './ui/spa/eoc/alert-list/index.tsx';

export const eocTeamAlertDetailRouteEntry = createEntry(eocTeamAlertDetailRoute, () => ({
	group: 'eoc',
	component: AlertList,
	layout: opsTeamLayout,

	resources: [
		...getNavigationResources(),
		...teamDashboardResources(),
		...alertListResources(),
		...alertDetailResources(),
		getConsolidationStateResource(),
		resourceWithCondition(
			() => fg('automation_discoverability_in_jsm'),
			getAutomationDiscoveryDismissResource,
		),
	],

	navigation: {
		menuId: MENU_ID.PEOPLE,
		sidebar: AsyncSidebarEocTeamDashboard,
	},

	forPaint: [LazyAtlassianNavigation, LazyAlertList, LazyTeamDashboardSidebar],

	bifrost: {
		bifrostGroup: 'shell-only',

		bundling: {
			packageName:
				'@atlassian/jira-router-routes-eoc-team-alerts-entries/src/eocTeamAlertDetailRouteEntry.tsx',
			whichExportToUse: 'eocTeamAlertDetailRouteEntry',
		},

		enabled: true,
	},
}));
